import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { use, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { LotDetailContext } from "../../../../Contexts/LotDetailContext";
import RecipeDialog from "../../../../Dialogs/RecipeDialog";
import RegradeButton from "../../LotSummaryFieldsSection/RegradeButton";

interface GradeFieldsProps {
    hasPackoutGrade: boolean;
    showGradeDialog?: boolean;
}

export function GradeFields({ hasPackoutGrade, showGradeDialog = true }: GradeFieldsProps) {
    const { t } = useTranslation();
    const {
        lotDetail: {
            summary: {
                lotNumber,
                grade,
                businessUnitCode,
                currentStatus,
                processingStatus,
                packoutGrade
            }
        },
        getLotDetail,

    } = use(LotDetailContext);

    const [showRecipeDialog, setShowRecipeDialog] = useState(false);
    const closeRecipeDialog = () => {
        getLotDetail(undefined, true); // Get quietly
        setShowRecipeDialog(false);
    };

    return (
        <>
            <Form.Group as={Col} sm={6} controlId="formGrade">
                <Row>
                    <Form.Label column sm={4}>{t('LotDetails.Summary.Grade')}:</Form.Label>
                    <Col sm={8} className="d-flex justify-content-start">
                        <Form.Control type="text" disabled value={grade ?? ""} />
                        {showGradeDialog &&
                            <Button variant="light" className="ms-3" onClick={() => setShowRecipeDialog(true)}>
                                <FontAwesomeIcon icon={faInfo} />
                            </Button>
                        }
                        {processingStatus !== "Queued" && processingStatus !== "Processing" && currentStatus !== "Graded" &&
                            <RegradeButton lotNumber={lotNumber} businessUnitCode={businessUnitCode} getLotDetail={getLotDetail} />
                        }
                    </Col>
                </Row>
            </Form.Group>
            {hasPackoutGrade &&
                <Form.Group as={Col} sm={6} controlId="formPackoutGrade">
                    <Row>
                        <Form.Label column sm={4}>{t('LotDetails.Summary.PackoutGrade')}:</Form.Label>
                        <Col sm={8} className="d-flex justify-content-start">
                            <Form.Control type="text" disabled value={packoutGrade ?? ""} />
                            <Button variant="light" className="ms-3" onClick={() => setShowRecipeDialog(true)}>
                                <FontAwesomeIcon icon={faInfo} />
                            </Button>
                        </Col>
                    </Row>
                </Form.Group>
            }
            {grade && businessUnitCode &&
                <RecipeDialog showDialog={showRecipeDialog} closeDialog={closeRecipeDialog} name={grade} businessUnitCode={businessUnitCode} />
            }
        </>
    );
}